var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-overlay select-hashtag", class: _vm.position },
    [
      _c("div", { staticClass: "steep1" }, [
        _c("div", { staticClass: "content searchHashtag" }, [
          _c("div", { staticClass: "input" }, [
            _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.textSearch,
                  expression: "textSearch",
                },
              ],
              ref: "inputSearch",
              attrs: {
                placeholder: _vm.$t("dash.post-creator.overlay.search-hashtag"),
              },
              domProps: { value: _vm.textSearch },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.sendSearchHashtags.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.textSearch = $event.target.value
                },
              },
            }),
          ]),
          _c(
            "div",
            { staticClass: "list-item hide-scrollbar" },
            [
              _vm.stateLoader
                ? _c("span", { staticClass: "loader" })
                : _vm.listHashtagAvailable.length ||
                  _vm.listHashtagSelect.length
                ? _vm._l(
                    _vm.listHashtagAvailable.length
                      ? _vm.listHashtagAvailable
                      : _vm.listHashtagSelect,
                    function (hashtag, index) {
                      return _c(
                        "div",
                        {
                          key: `hashtag${index}`,
                          staticClass: "item",
                          on: {
                            click: function ($event) {
                              return _vm.selectHashtag(hashtag)
                            },
                          },
                        },
                        [
                          _vm.listHashtagSelect.find(
                            (v) => v.hashtag == hashtag.hashtag
                          )
                            ? _c("div", { staticClass: "icon selected" }, [
                                _c("i", { staticClass: "fa-solid fa-check" }),
                              ])
                            : _c("div", { staticClass: "icon" }, [
                                _c("i", {
                                  staticClass: "fa-regular fa-hashtag",
                                }),
                              ]),
                          _c("div", { staticClass: "info" }, [
                            _c("p", { staticClass: "name" }, [
                              _vm._v("#" + _vm._s(hashtag.hashtag)),
                            ]),
                            _c("p", { staticClass: "count" }, [
                              _vm._v("Sur "),
                              _c("span", { staticClass: "countHashtag" }, [
                                _vm._v(_vm._s(hashtag.count)),
                              ]),
                              _vm._v(" posts"),
                            ]),
                          ]),
                        ]
                      )
                    }
                  )
                : _vm.textSearch
                ? _c("p", { staticClass: "no-result" }, [
                    _vm._v(
                      _vm._s(_vm.$t("dash.post-creator.overlay.no-result"))
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _c("div", { staticClass: "btns" }, [
        _vm.listHashtagSelect.length
          ? _c(
              "div",
              { staticClass: "btn-secondary", on: { click: _vm.handlerApply } },
              [
                _vm._v(
                  _vm._s(_vm.$t("dash.post-creator.action.apply")) +
                    " (" +
                    _vm._s(_vm.listHashtagSelect.length) +
                    ")"
                ),
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "btn-secondary", on: { click: _vm.close } }, [
          _vm._v(_vm._s(_vm.$t("dash.button.close"))),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }